// extracted by mini-css-extract-plugin
export default {"header":"S0y6KHlS","notificationList":"Qd30nQF2"};